/* istanbul ignore file */
// Ignoring coverage for this file since it is just a re-export
// eslint-disable-next-line lumapps/do-not-import-axios
import axios from 'axios';

const { isAxiosError } = axios;

export { default, BaseApiHeaders } from './api/BaseApi';
export * from './utils';
export * from './types';
export { axios as dangerousAxiosInstanceUseOnlyIfNeeded, isAxiosError as isBaseApiError };
